// @flow
import { useEffect } from 'react';
import {
  setVoucherContext,
  clearVoucherContext,
  trackVoucherTabViewed,
} from '../../utils/hudVoucherTracking';

type Args = {
  voucherId?: ?string,
  submissionStatus?: ?string,
  contractNumber?: ?string,
  propertyId?: ?string,
  tab?: ?string,
};

// Keeps the RUM `voucher` context in sync with the screen so every error raised here carries the voucher,
// tab and last step. Called with no args on the list page only to clear the context on the way out.
export function useVoucherRumContext({
  voucherId,
  submissionStatus,
  contractNumber,
  propertyId,
  tab,
}: Args = {}): void {
  useEffect(() => {
    if (!voucherId) return;
    setVoucherContext({
      voucherId,
      status: submissionStatus,
      contractNumber,
      propertyId,
    });
  }, [voucherId, submissionStatus, contractNumber, propertyId]);

  useEffect(() => {
    if (tab) trackVoucherTabViewed(tab);
  }, [tab]);

  useEffect(() => () => clearVoucherContext(), []);
}
